import { z } from 'zod';

import { UserDto, UserDtoScheme, UserWithTotalDto, UserWithTotalDtoScheme } from '~modules/user/model';
import { client } from '~shared/api';

export async function searchUser(search: string, parent?: number): Promise<UserDto[]> {
	const params = new URLSearchParams({
		limit: '10',
		search: search,
	});

	if (parent) {
		params.append('parent', parent.toString());
	}

	const url = `/user?${params.toString()}`;
	const data = await client.get<UserDto>(url);
	return UserDtoScheme.array().parse(data);
}

export async function loadUser(search: string, limit: number, offset?: number): Promise<UserWithTotalDto> {
	const params = new URLSearchParams({
		limit: limit.toString(),
		search: search,
	});

	if (offset) {
		params.append('offset', offset.toString());
	}

	const url = `/user/search?${params.toString()}`;
	const data = await client.get<UserWithTotalDto>(url);
	return UserWithTotalDtoScheme.parse(data);
}

export async function loadUserById(id: number): Promise<UserDto | null> {
	const data = await client.get(`/user/by-id/${id}`);
	if (!data) return null;
	return UserDtoScheme.parse(data);
}

export async function loadBySection(section_id: number): Promise<UserDto[]> {
	const data = await client.get<UserDto>(`/user/section/${section_id}`);
	return z.array(UserDtoScheme).parse(data);
}

export async function setSectionId(user_id: number, section_id: number): Promise<void> {
	await client.post(`/user/section/${user_id}/${section_id}`);
}

export async function changeUsersSections(section_id: number, user_ids: number[]) {
	await client.put(`/user/section/${section_id}`, { user_ids });
}

export async function searchUserByAvailableSections(
	search: string,
	offset: number = 0,
	ignoreSections?: boolean,
): Promise<UserDto[]> {
	const params = new URLSearchParams();
	params.append('limit', '10');
	params.append('offset', offset.toString());

	if (search) {
		params.append('search', search);
	}

	if (ignoreSections) {
		params.append('ignoreSections', 'true');
	}

	const data = await client.get<UserDto>(`/user/section?${params.toString()}`);
	return z.array(UserDtoScheme).parse(data);
}
